var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharpen = function SvgSharpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12.0089 5.01512C11.6665 5.00858 11.3288 5.09488 11.0315 5.26489C10.7342 5.43489 10.4884 5.68224 10.3204 5.98066L4.69311 16.4565C4.58461 16.6637 4.52025 16.8911 4.50406 17.1244C4.48787 17.3577 4.52021 17.5918 4.59905 17.812C4.67789 18.0321 4.80152 18.2335 4.96213 18.4035C5.12273 18.5735 5.31684 18.7084 5.53218 18.7996C5.79368 18.9207 6.07836 18.9837 6.36657 18.9841H17.6235C18.1028 19.0007 18.5692 18.827 18.9208 18.5008C19.2724 18.1746 19.4807 17.7226 19.5 17.2433C19.4999 16.9707 19.4321 16.7023 19.3027 16.4623L13.6755 5.98645C13.5103 5.69002 13.2684 5.44346 12.9752 5.27257C12.682 5.10168 12.3483 5.01277 12.0089 5.01512Z"
  })));
};
export default SvgSharpen;